import React from 'react'
import { PickersDay, pickersDayClasses, PickersDayProps } from '@mui/x-date-pickers'
import { endOfMonth, endOfWeek, isSameDay, startOfMonth, startOfWeek } from 'date-fns'
import { format } from 'date-fns/esm'
import { isBetweenDate } from '../../common/utils/date'

function renderPickerDay(selectedDate: Date) {
  const callback = (day: Date, _: Date[], pickersDayProps: PickersDayProps<Date>) => {
    const startDate = startOfWeek(selectedDate)
    const endDate = endOfWeek(selectedDate)

    if (!isBetweenDate(day, startDate, endDate)) {
      return <PickersDay {...pickersDayProps} />
    }

    return (
      <PickersDay
        {...pickersDayProps}
        disableMargin={false}
        sx={{
          ...{ background: '#a9ec8a80', borderRadius: 0, margin: 0, width: '40px' },
          // 日付が選択している日付と同じ場合
          ...(isSameDay(day, selectedDate)
            ? {
                '& .MuiTouchRipple-root': {
                  backgroundColor: '#62c234',
                  borderRadius: '50%',
                },
                '& .MuiTouchRipple-root::after': {
                  alignItems: 'center',
                  content: `"${format(day, 'd')}"`,
                  display: 'flex',
                  height: '100%',
                  justifyContent: 'center',
                },
              }
            : {}),
          ...(isSameDay(day, startDate) ||
          isSameDay(day, startOfMonth(selectedDate)) ||
          isSameDay(day, startOfMonth(day))
            ? // 日付がカレンダーの左端の場合
              { borderRadius: '50% 0 0 50%' }
            : isSameDay(day, endDate) ||
              isSameDay(day, endOfMonth(selectedDate)) ||
              isSameDay(day, endOfMonth(day))
            ? // 日付がカレンダーの右端の場合
              { borderRadius: '0 50% 50% 0' }
            : {}),
          [`&&.${pickersDayClasses.selected}`]: {
            backgroundColor: '#a9ec8a80',
          },
        }}
      />
    )
  }
  return callback
}

export default renderPickerDay
